import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { IntlService } from '../../core/services/intl.service';

@Directive({
  selector: '[ifLanguage]'
})
export class IfLanguageDirective {

  @Input() ifLanguage: string;

  public languageChangedSubscription: Subscription;
  public originalDisplayStyle: string;

  constructor(private el: ElementRef, private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private intlService: IntlService) { }

  ngOnInit() {
    this.originalDisplayStyle = this.el.nativeElement.style?.display || 'block';

    this.setVisibility();
    this.languageChangedSubscription = this.intlService.languageChanged().subscribe(() => {
      this.setVisibility();
    });
  }

  setVisibility() {
    const currentLanguage = this.intlService.getCurrentLanguage();

    let shouldDisplay = false;
    if (this.ifLanguage.startsWith('!')) {
      shouldDisplay = this.ifLanguage.substring(1) !== currentLanguage;
    } else {
      shouldDisplay = this.ifLanguage === currentLanguage;
    }

    this.viewContainer.clear();

    if (shouldDisplay) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }

  }
}
